import NotificationsContext, { AppNotification } from 'contexts/notifications';
import { useCallback, useContext } from 'react';

export const useAddNotification = () => {
  const { addNotification, removeNotification } = useContext(
    NotificationsContext
  );

  return useCallback(
    (notification: AppNotification, timeout?: number) => {
      addNotification(notification);

      if (typeof timeout !== 'undefined' && timeout > 0) {
        setTimeout(() => removeNotification(notification), timeout);
      }
    },
    [addNotification, removeNotification]
  );
};
